import { create } from 'zustand';
import { apiService } from 'services';

import type { ChannelSupplierDetailVo } from "services/api";
import {
  SupplierManagerPermissionVo
} from "services/api";
import { ActionType, getActionsByDetail } from '../utils';

type SupplierDetail = ChannelSupplierDetailVo & {
  // 以action为key的 数组
  $action?: Record<ActionType, boolean>;
};

type OpenType = "new" | "serviceNew" | "view" | "edit" | "check"


// 默认供应商详情
// const defaultSupplier: SupplierDetail = {
// main_supplier: {
//   name: "测试公司长长",
//   abbr_name: "测试公司",
//   address: "测试公司长长",
//   staff_amount: 60,
//   former_employee_founded: false,
//   attachments: [],
// },
// channel_type: "01",
// content: {
//   channel_type: "01",
//   content: "哒哒哒哒哒哒",
//   advantage_resource_platform: ["1"],
//   main_customers: "主要客户",
//   examples: "服务案例 (简举)222222",
//   net_ease_game_examples: "网易服务案例 (简举)111111",
//   advance_scale: "1",
//   recommended_team: "少时诵诗书所所",
//   recommender: "的点点滴滴",
//   recommender_mail: "啊啊啊啊",
//   recommendation_reason: "顶顶顶顶",
// },
// contacts: [{
//   id: "22222",
//   name: "测试333",
//   position: "测试444",
//   mail: "测试",
//   tel: "测试",
// }],
// principals: [{
//   id: "222323",
//   name: "测试222",
//   position: "测试555",
//   mail: "测试66",
//   tel: "测试77",
// }],
// // account_list: [{
// //   username: "测试",
// //   email: "测试",
// //   popo_account: "测试",
// // }],
// type_info: {
//   type: "",
//   valid_date: "",
//   invalid_date: "",
// },
// };



// 默认供应商详情
const defaultSupplier: SupplierDetail = {
  id: "",
  main_supplier: {
    id: "",
    name: "",
    abbr_name: "",
    address: "",
    staff_amount: 0,
    former_employee_founded: undefined,
    attachments: [],
  },
  channel_type: "01",
  content: {
    channel_type: "01",
    content: "",
    advantage_resource_platform: [],
    main_customers: "",
    examples: "",
    net_ease_game_examples: "",
    advance_scale: "",
    recommended_team: "",
    recommender: "",
    recommender_mail: "",
    recommendation_reason: "",
  },
  contacts: [],
  principals: [],
  association_accounts: [],
  type_info: {
    type: "",
    valid_date: "",
    invalid_date: "",
  },
};




type SupplierDetailState = {
  detailShow: boolean;
  openType: OpenType;
  supplierDetail: SupplierDetail | null;
  // 供应商渠道权限
  channelPermission: string[];
  // 供应商管理权限
  supplierManagerPermission: SupplierManagerPermissionVo;


  viewToEdit: () => void;
  setSupplierDetail: (supplierDetail: SupplierDetail) => void;
  resetSupplierDetail: () => void;
  closeDetail: () => void;
  openNewDetail: (params: {
    name: string,
    channel_type: string,
  }) => void;
  openServiceNewDetail: (params: { name: string, channel_type: string, main_supplier_id: string }) => void;
  openViewDetail: (id: string) => void;
  openEditDetail: (id: string) => void;
  openCheckDetail: (id: string) => void;
  getSupplierDetail: (id: string) => Promise<SupplierDetail>;
  createSupplier: (params: { supplierForm: SupplierDetail, submit?: boolean }) => Promise<any>;
  createChannelSupplier: (params: { supplierForm: SupplierDetail, submit?: boolean, main_supplier_id?: string }) => Promise<any>;
  updateSupplier: (params: { supplierForm: SupplierDetail }) => Promise<any>;
  updateApprovalSupplier: (params: { supplierForm: SupplierDetail, submit?: boolean }) => Promise<any>;
  passApproval: (id: string) => Promise<any>;
  updateChannelPermission: () => void;
};



export const useSupplierDetail = create<SupplierDetailState>()((set, get) => ({
  detailShow: false,
  openType: "view",
  supplierManagerPermission: {
    data_permissions: [],
  },
  channelPermission: [],
  supplierDetail: defaultSupplier,
  viewToEdit: () => {
    set({ openType: "edit" });
  },
  resetSupplierDetail: () => {
    set({ supplierDetail: defaultSupplier });
  },
  setSupplierDetail: (supplierDetail) => {
    set({ supplierDetail });
  },
  closeDetail: () => {
    // set({ detailShow: false, supplierDetail: defaultSupplier });
    set({ openType: "view" });
  },
  openNewDetail: (
    {
      name,
      channel_type
    }) => {
    set({
      detailShow: true,
      openType: "new",
      supplierDetail: {
        ...defaultSupplier,
        channel_type,
        main_supplier: {
          ...defaultSupplier.main_supplier,
          name,
        },
      }
    });
  },
  updateChannelPermission: async () => {
    const result = await apiService.supplierControllerNewGetSupplierManagerPermission()
    const permissions = result?.data?.data_permissions
    if (permissions) {
      set({
        supplierManagerPermission: result.data,
        channelPermission: permissions
      });
    }
  },
  openServiceNewDetail: ({
    main_supplier_id,
    name,
    channel_type,
  }) => {
    set({
      detailShow: true,
      openType: "serviceNew",
      supplierDetail: {
        ...defaultSupplier,
        channel_type,
        main_supplier: {
          ...defaultSupplier.main_supplier,
          id: main_supplier_id,
          name,
        },
      },
    });
  },
  openViewDetail: async (id) => {
    const res = await get().getSupplierDetail(id);
    set({ detailShow: true, openType: "view" });
    return res;
  },
  openEditDetail: (id) => {
    const res = get().getSupplierDetail(id);
    set({ detailShow: true, openType: "edit" });
    return res;
  },
  openCheckDetail: (id) => {
    const res = get().getSupplierDetail(id);
    set({ detailShow: true, openType: "check" });
    return res;
  },
  getSupplierDetail: async (id: string) => {
    const detail = await apiService.supplierControllerNewQueryById({
      id,
    });
    const viewDetail = {
      ...detail.data,
      $action: getActionsByDetail(detail.data),
    }
    set({ supplierDetail: viewDetail });
    return viewDetail;
  },
  // 创建渠道供应商
  createChannelSupplier: async ({
    supplierForm,
    submit = false,
    main_supplier_id,
  }: {
    supplierForm: SupplierDetail,
    submit?: boolean,
    main_supplier_id?: string,
  }) => {
    const supplierDetail = get().supplierDetail;
    const $main_supplier_id = main_supplier_id || get().supplierDetail?.main_supplier?.id;
    const $channel_type = supplierForm.channel_type || supplierDetail.channel_type;
    const supplierContent = await apiService.supplierControllerNewCreate({
      main_supplier_id: $main_supplier_id,
      channel_type: $channel_type,
      content: {
        service_info: supplierForm.content,
        contacts: supplierForm.contacts,
        principals: supplierForm.principals,
      },
      need_submit: !!submit,
    })
    console.log('supplierControllerNewCreate', supplierContent);
    return supplierContent;
  },
  // 创建主供应商和渠道供应商
  createSupplier: async ({
    supplierForm,
    submit = false,
  }: {
    supplierForm: SupplierDetail,
    submit?: boolean,
  }) => {
    console.log('supplierForm', supplierForm);
    const res = await apiService.mainSupplierCreateMainSupplier({
      name: supplierForm.main_supplier.name,
      abbr_name: supplierForm.main_supplier.abbr_name,
      address: supplierForm.main_supplier.address,
      staff_amount: supplierForm.main_supplier.staff_amount,
      former_employee_founded: supplierForm.main_supplier.former_employee_founded,
      attachments: supplierForm.main_supplier.attachments,
    })
    console.log('mainSupplierCreateMainSupplier', res);
    const supplierId = res.data;
    return get().createChannelSupplier({ supplierForm, submit, main_supplier_id: supplierId });
  },

  // 更新有效渠道供应商
  updateSupplier: async ({ supplierForm }: {
    supplierForm: SupplierDetail,
  }) => {
    const detail = get().supplierDetail;
    const mainSupplierId = detail?.main_supplier?.id;
    const mainSupplier = await apiService.mainSupplierUpdateMainSupplier({
      id: mainSupplierId,
    }, {
      name: supplierForm.main_supplier.name,
      abbr_name: supplierForm.main_supplier.abbr_name,
      address: supplierForm.main_supplier.address,
      staff_amount: supplierForm.main_supplier.staff_amount,
      former_employee_founded: supplierForm.main_supplier.former_employee_founded,
      attachments: supplierForm.main_supplier.attachments,
    })
    console.log('mainSupplierUpdateMainSupplier', mainSupplier);
    const supplierId = detail.id;
    const uptate = await apiService.supplierControllerNewUpdateValid({
      id: supplierId,
    }, {
      content: {
        service_info: supplierForm.content,
        contacts: supplierForm.contacts,
        principals: supplierForm.principals,
      },
      account_list: supplierForm.account_list,
    })
    console.log('supplierControllerNewUpdateUnApproval', uptate);
    return uptate;
  },

  // 更新未审批供应商
  updateApprovalSupplier: async ({
    supplierForm,
    submit = false,
  }: {
    supplierForm: SupplierDetail,
    submit?: boolean,
  }) => {
    const detail = get().supplierDetail;
    const mainSupplierId = detail?.main_supplier?.id;
    const mainSupplier = await apiService.mainSupplierUpdateMainSupplier({
      id: mainSupplierId,
    }, {
      name: supplierForm.main_supplier.name,
      abbr_name: supplierForm.main_supplier.abbr_name,
      address: supplierForm.main_supplier.address,
      staff_amount: supplierForm.main_supplier.staff_amount,
      former_employee_founded: supplierForm.main_supplier.former_employee_founded,
      attachments: supplierForm.main_supplier.attachments,
    })
    console.log('mainSupplierUpdateMainSupplier', mainSupplier);
    const supplierId = detail.id;
    const uptate = await apiService.supplierControllerNewUpdateUnApproval({
      id: supplierId,
    }, {
      content: {
        service_info: supplierForm.content,
        contacts: supplierForm.contacts,
        principals: supplierForm.principals,
      },
      need_submit: !!submit,
    })
    console.log('supplierControllerNewUpdateUnApproval', uptate);
    return uptate;
  },

  // 审核通过
  passApproval: async (id: string) => {
    const res = await apiService.supplierControllerNewApprovalPass({
      id,
    });
    return res;
  }
}));


